const navbarContainer = document.getElementById('navbar-container');
const navbarToggle = document.getElementById('navbar-toggle');

if (navbarToggle && navbarContainer) {
  navbarToggle.addEventListener('click', (e) => {
    e.preventDefault();
    navbarContainer.classList.toggle('isOpen')
  });
}
